import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedItem } from 'store/reducers/mainSlice';

import { Dropdown } from 'react-bootstrap';
import { Tooltip } from '@mui/material';
import StatusBadge from 'ui-component/StatusBadge';
import Pagination from 'ui-component/Pagination';
import { FaPlus, FaSearch } from 'react-icons/fa';
import Filter from 'ui-component/filter-menu/Filter';
import { Skeleton } from '@mui/material';
import { TbDatabaseExclamation } from 'react-icons/tb';
import { LiaTimesSolid } from 'react-icons/lia';
import UserPermissions from 'views/settings/UserPermissions';
import { RiShieldUserLine } from 'react-icons/ri';
import { ImSpinner2 } from 'react-icons/im';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import toast from 'react-hot-toast';
import moment from 'moment';
import usePageTitle from 'hooks/usePageTitle';
import useIsMobile from 'utils/isMobileUtils';
import { ViewDetailsIcon, DeleteIcon } from 'ui-component/custom-icons/icons';

const Users = () => {
	const [setPageTitle] = usePageTitle('Users');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);

	const history = useNavigate();
	const [userList, setUserList] = useState([]);
	const [show, setShow] = useState('');
	const [roleslist, setRoleslist] = useState([]);
	const [pagination, setpagination] = useState([]);
	const [isLoading, setIsloading] = useState(false);
	const permission = useSelector((state) => state.main.user.permissionToAction);
	const currentUserRole = useSelector((state) => state.main.user?.role[0]?.name);
	const staterole = useSelector((state) => state.main.setstateuserrole);
	const dispatch = useDispatch();

	const [searchField, setSearchField] = useState('');
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [filters, setFilters] = useState();
	const [activeFilters, setActiveFilters] = useState({});
	const [isFirstLoad, setIsFirstLoad] = useState(true);

	const [userPermissions, setUserPermissions] = useState();

	const getAllrole = () => { };
	const deleteuserData = (data) => {
		setShow(data);
	};

	const handleSearch = (e) => {
		let text = e.target.value;
		setSearchField(text);

		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		let timeout = setTimeout(() => {
			setIsloading(true);
			if (text.length > 2) {
				api.filterUsers(activeFilters, text).then((res) => {
					setIsloading(false);
					setUserList(res.data.data);
					setpagination(res.data);
				});
			} else if (text.length > 0 && text.length <= 2) {
				setIsloading(false);
			} else {
				api.filterUsers(activeFilters, null).then((res) => {
					setIsloading(false);
					setUserList(res.data.data);
					setpagination(res.data);
				});
			}
		}, 1000);

		setSearchTimeout(timeout);
	};

	const handleClose = () => setShow('');

	const [loadingPermissionId, setLoadingPermissionId] = useState();

	const openPermissions = (id) => {
		setLoadingPermissionId(id);
		api.getUserPermissionsList(id).then((res) => {
			if (res?.status) {
				setUserPermissions({
					user: userList?.find((u) => u?.id == id),
					permissions: res?.data
				});
			}
			setLoadingPermissionId(null);
		});
	};

	const handleDelete = (id) => {
		toast.promise(
			api.deleteUser(id).then((res) => {
				if (res.status) {
					handleFilter();
					setShow(null);
				}
				return res?.status ? res : abc;
			}),
			{
				loading: 'Deleting User...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete user</b>
			}
		);
	};
	const viewUserData = (id) => {
		const currentUser = userList.filter((item) => item.id === id);
		dispatch(setSelectedItem(currentUser[0]));
		history(`/settings/user/${id}`);
	};
	const updateUser = (id) => {
		const currentUser = userList.filter((item) => item.id === id);
		dispatch(setSelectedItem(currentUser[0]));
		history(`/settings/user/edit/${id}`);
	};

	const handleFilter = () => {
		setIsloading(true);
		// NOTE: Ensure you have an API endpoint `api.filterUsers` that can handle filter and search parameters.
		api.filterUsers(activeFilters, searchField?.length > 2 ? searchField : null)
			.then((res) => {
				setIsloading(false);
				setUserList(res.data.data);
				setpagination(res.data);
			})
			.catch((error) => {
				setIsloading(false);
				console.error('Failed to filter users:', error);
			});
	};

	useEffect(() => {
		if (!isFirstLoad) {
			handleFilter();
		}
	}, [activeFilters]);

	useEffect(() => {
		if (!staterole) {
			getAllrole();
		} else {
			setRoleslist(staterole);
		}
	}, [staterole]);
	

	useEffect(() => {
		getFiltersList();
		handleFilter(); // This will now fetch the initial unfiltered list
		setIsFirstLoad(false);
	}, []);

	const getFiltersList = () => {
		api.getRolesFilter().then((res) => {
			setFilters(res.data);
		})
	}
	const handleData = (data) => {
		setUserList(data.data);
		setpagination(data);
	};

	const isMobile = useIsMobile();
	return (
		<>
			<div className="row " style={{ height: '100%' }}>
				{/* Area Chart */}
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									Users
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
								<PermissionAllowed permissions={['Create User (Button)']}>
									<Link to={'/settings/user/create'} className="btn btn-primary btn-outlined-main white-var">
										<FaPlus /> New User
									</Link>
								</PermissionAllowed>
							</div>
						</div>
					</div>

					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							gap: 10,
							paddingTop: 0,
							paddingBottom: 5,
							paddingLeft: 20,
							paddingRight: 20
						}}
						className="show-on-mobile"
					>
						<form className="form-inline navbar-search" style={{ flex: 1 }}>
							<div style={{ position: 'relative', width: '100%' }}>
								<input
									type="text"
									className="form-control bg-white border"
									placeholder="Search"
									aria-label="Search"
									aria-describedby="basic-addon2"
									onChange={handleSearch}
									// onChange={(e) => {
									// 	setSearchField(e.target.value);
									// }}
									style={{ width: '100%', paddingRight: 36 }}
								/>
								<span
									className="searchIcon"
									style={{
										position: 'absolute',
										right: 10,
										top: '50%',
										transform: 'translateY(-50%)',
										color: '#888',
										pointerEvents: 'none'
									}}
								>
									<FaSearch />
								</span>
							</div>
						</form>
						<div style={{ flexShrink: 0 }}>
							<Filter
								activeFilters={activeFilters}
								onSubmit={setActiveFilters}
								filters={filters}
								noScrolling={true}
								source={'user'}
							/>
						</div>
					</div>
					<div className="section-head hide-on-mobile">
						<h2></h2>
						<div className="actions">
							<PermissionAllowed permissions={['Create User (Button)']}>
								<Link to={'/settings/user/create'} className="btn btn-primary btn-outlined-main white-var">
									<FaPlus /> New User
								</Link>
							</PermissionAllowed>
						</div>
					</div>
					<div className={`card shadow-sm  bg-white mb-4  ${isMobile ? 'table-card shorter-table' : ''}`}>
						<div className=" align-items-center justify-content-between TableSerachBar">
							<div>
								<Filter
									activeFilters={activeFilters}
									onSubmit={setActiveFilters}
									filters={filters}
									noScrolling={true}
									source={'user'}
								/>
							</div>
							<form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
								<div className="input-group">
									<input
										type="text"
										className="form-control bg-white border"
										placeholder="Search"
										aria-label="Search"
										aria-describedby="basic-addon2"
										onChange={handleSearch}
										style={{ width: '100%' }}
									/>
									<span className="searchIcon">
										<FaSearch />
									</span>
								</div>
							</form>
						</div>
						<div className="estimation-table-area">
							<div className="table-side">
								{!isMobile ? (
									<div className="table-responsive-xl tableData UserListing p-2">
										<table className="table pm-table min-width-unset">
											<thead>
												<tr className="sticky-header">
													<th scope="col" width="">
														Name
													</th>
													<th scope="col">Email</th>
													<th scope="col">Phone</th>
													
													{!userPermissions && (
														<>
															<th scope="col">Role</th>
															<th scope="col" width={'100'}>Status</th>
															<th scope="col" width={'160'}>Last logged in</th>
														</>
													)}
												</tr>
											</thead>
											<tbody>
												{isLoading ? (
													[...Array(25)].map((e, i) => (
														<tr>
															{[...Array(6)].map((e, i) => (
																<td>
																	<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
																</td>
															))}
														</tr>
													))
												) : (
													<>
														{userList?.map((row, index) => {
															const maxLength = 20;
															return (
																<tr
																	key={index}
																	className={`hover-row ${userPermissions?.user?.id == row?.id ? 'selected-row' : ''}`}
																>
																	<td className="align-middle">{row?.first_name} {row?.last_name}</td>
																	<td className="align-middle">{row?.email}</td>

																	<td className="align-middle">{row?.mobile}</td>
																	{!userPermissions && (
																		<>
																			<td className="align-middle">{row?.role?.name}</td>
																			<td className="align-middle">
																				<StatusBadge itemStatus={row.status === 1 ? 'Active' : 'Inactive'} />
																			</td>
																			<td className="align-middle">{row?.last_login_at ? moment(row?.last_login_at).format('DD MMM YYYY hh:mm A') : '-'}</td>
																		</>
																	)}

																	<td className="hover-button-container">
																		<div>
																			<div className="hover-button">
																				<PermissionAllowed permissions={['View User Permissions (Button)']}>
																					<Tooltip title={'Permissions'} arrow placement="top">
																						<div
																							className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																							style={{ marginLeft: '8px' }}
																							onClick={() => openPermissions(row.id)}
																						>
																							{loadingPermissionId == row.id ? <ImSpinner2 className="fa-spin" /> : <RiShieldUserLine />}
																						</div>
																					</Tooltip>
																				</PermissionAllowed>
																				<PermissionAllowed permissions={['Edit User (Button)']}>
																					<Tooltip title={'View'} arrow placement="top">
																						<div
																							className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																							style={{ marginLeft: '8px' }}
																							onClick={() => updateUser(row.id)}
																						>
																							<ViewDetailsIcon height={'16'} width={'16'} />
																						</div>
																					</Tooltip>
																				</PermissionAllowed>

																				<PermissionAllowed permissions={['Delete User (Button)']}>
																					<Tooltip title={'Delete'} arrow placement="top">
																						<div
																							className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																							style={{ marginLeft: '8px' }}
																							onClick={() => deleteuserData(row)}
																						>
																							<div style={{ margin: 'auto 3px' }}>
																								<DeleteIcon height="14px" width="14px" />
																							</div>
																						</div>
																					</Tooltip>
																				</PermissionAllowed>
																			</div>
																		</div>
																	</td>
																</tr>
															);
														})}
														{userList?.length < 1 && (
															<tr className="no-hover">
																<td colSpan={7}>
																	<div className="not-found-container">
																		<div className="not-found-icon">
																			<TbDatabaseExclamation />
																		</div>
																		<h6 className="not-found-text">No Data Available</h6>
																	</div>
																</td>
															</tr>
														)}
													</>
												)}
											</tbody>
										</table>
									</div>
								) : (
									<div
										className="mobile-product-list"
										style={{ height: 'calc(100dvh - 320px)', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}
									>
										{isLoading ? (
											[...Array(25)].map((_, i) => (
												<div
													key={i}
													className="mobile-product-card skeleton"
													style={{ borderRadius: 12, background: '#f5f5f5', padding: 16, minHeight: 80 }}
												>
													<Skeleton variant="rounded" width={'100%'} height={60} />
												</div>
											))
										) : userList?.length > 0 ? (
											userList.map((row, index) => (
												<div
													key={index}
													className="mobile-product-card"
													style={{
														borderBottom: '1px solid #eee',
														padding: '10px 20px',
														background: index % 2 === 0 ? '#fff' : '#f9f9f9',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														gap: 12,
														width: '100%'
													}}
														onClick={() => {
															viewUserData(row.id);
														}}
												>
													<div className="mobile-product-info">
														<div className="mobile-product-name" style={{ fontWeight: 500 }}>
															{row.first_name} {row.last_name}
														</div>
														<div className="">{row.email}</div>
														<div className="">{row.role?.name}</div>
													</div>
													<div className="mobile-product-actions">
														<PermissionAllowed permissions={['Edit User (Button)', 'Delete User (Button)']}>
															<Dropdown className="btnDel iconbtn">
																<Dropdown.Toggle as="span" id={`dropdown-toggle-${index}`}>
																	<i className="fas fa-ellipsis-h "></i>
																</Dropdown.Toggle>
																<Dropdown.Menu>
																	<PermissionAllowed permissions={['Edit User (Button)']}>
																		<Dropdown.Item onClick={() => updateUser(row.id)}>Edit</Dropdown.Item>
																	</PermissionAllowed>
																	<PermissionAllowed permissions={['Delete User (Button)']}>
																		<Dropdown.Item onClick={() => deleteuserData(row)}>Delete</Dropdown.Item>
																	</PermissionAllowed>
																</Dropdown.Menu>
															</Dropdown>
														</PermissionAllowed>
													</div>
												</div>
											))
										) : (
											<div>No Data Available</div>
										)}
									</div>
								)}
								<div style={{ paddingBottom: '10px' }}>
									<Pagination pagination={pagination} data={handleData} onLoading={(e) => setIsloading(e)} />
								</div>
							</div>

							{userPermissions && (
								<div className="estimate-detail-container">
									<div className="row m-0 p-2">
										<div className="col-12">
											<div className="d-flex justify-content-between align-items-center">
												<h6 className="est-title" style={{ fontWeight: 500, fontSize: '16px' }}>
													Permissions - {userPermissions?.user?.first_name} {userPermissions?.user?.last_name}
												</h6>
												<LiaTimesSolid style={{ cursor: 'pointer' }} onClick={() => setUserPermissions(null)} />
											</div>
											<UserPermissions onClose={() => setUserPermissions(null)} data={userPermissions} />
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

			{show && (
				<DeleteConfirmation
					show={show}
					handleClose={handleClose}
					handleDelete={handleDelete}
					title="Confirm"
					message={`Are you sure you want to delete ${show?.first_name} ${show?.last_name || ''}`}
				/>
			)}
		</>
	);
};

export default Users;

function CustomToggle({ children, onClick }) {
	return (
		<>
			<a
				className="dropdown-toggle"
				href="#"
				role="button"
				id="dropdownMenuLink"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
				onClick={onClick}
			>
				{children}
			</a>
		</>
	);
}
